const pad = (number, targetLength) => number.toString().padStart(targetLength, 0);

export const unixToHour = (unixTimeStamp) => {
  const date = new Date(unixTimeStamp);

  return `${pad(date.getHours(), 2)}:${pad(date.getMinutes(), 2)}`;
};
